export const SHOW_POPUP = 'SHOW_POPUP';

export const showPopup = data => {
  return {
    type: SHOW_POPUP,
    data: data
  };
};